import React, { Component } from "react";
import { Accessor, ColorX, LocaleX } from "IZOX/STATIC";
import PropsType from "prop-types";
import { HStack, VStack, XText } from "IZOX/_X";
import ReactSignatureCanvas from "react-signature-canvas";
import OperBar from "IZOX/BLOCKS/Libs/OperBar/OperBar";

/**
 * @augments {Component<Props, State>}
 */
class Signizo extends Component {

  static propTypes = {
    width: PropsType.number,
    onConfirm: PropsType.func,
    onCancel: PropsType.func,
    onClear: PropsType.func
  }

  static defaultProps = {
    width: 500,
    onConfirm: null,
    onCancel: null,
    onClear: null
  }

  constructor(){
    super();
    this.state = {};
  }

  componentDidMount(){
    this._setAllStates();
  }

  componentDidUpdate(prevProps, prevState){
    if(!Accessor.IsIdentical(prevProps, this.props, Object.keys(Signizo.defaultProps))){
      this._setAllStates();
    }
  }

  componentWillUnmount() {
    this.setState = (state, callback) => {
      return;
    };
  }

  shouldComponentUpdate(nextProps, nextState){
    let propIdentical = Accessor.IsIdentical(nextProps, this.props, Object.keys(Signizo.defaultProps));
    let stateIdentical = Accessor.IsIdentical(nextState, this.state, null);
    if(propIdentical && stateIdentical){
      return false;
    }
    return true;
  }

  _setAllStates = (callback) => {
    this.setState((state, props) => ({
      ...props,
    }), callback);
  }

  _onConfirm = () => {
    let {onConfirm} = this.props;
    let {base64} = this.state;
    onConfirm?.(base64);
  };

  _onCancel = () => {
    let {onCancel} = this.props;
    onCancel?.();
  };

  _onSave = () => {
    let base64 = this.signatureCanvas?.toDataURL();
    this.setState({
      base64: base64
    });
  }

  _onClear = () => {
    let {onClear} = this.props;
    this.setState({
      base64: ""
    });
    onClear?.();
  }

  ClearSignature = () => {
    this.signatureCanvas?.clear();
    this._onClear();
  }

  render(){
    let {width} = this.props;
    return (
      <VStack width={width} spacing={5} alignItems={"flex-start"} 
        shadow shadowSize={2} shadowColor={ColorX.CSS("aliceblue", 0.5)}
        round={10} bgColor={ColorX.DayNight({day: "pureWhite", night: "dmBgDark"})}>
        <HStack pH={10} pT={5} HAlign="[">
          <XText bold color={ColorX.DayNight({day: "cmDarkBlue", night: "dmWhite"})}>
            {LocaleX.Parse({EN: "Sign Here: ", TC: "簽署:"})}
          </XText>
        </HStack>
        <VStack pH={5}>
          <VStack bW={1} bColor={ColorX.CSS("greyOut", 0.8)} fullWidth
            bgColor={ColorX.CSS("pureWhite")}>
            <ReactSignatureCanvas
              ref={e => this.signatureCanvas = e}
              canvasProps={{
                width: width * 0.98, 
                height: width * 0.5
              }}
              onEnd={this._onSave}
              />
          </VStack>
        </VStack>
        <OperBar onConfirm={this._onConfirm} buttons={["Cancel", "Clear", "Confirm"]}
          onCancel={this._onCancel} onClear={this.ClearSignature}/>
      </VStack>
    );
  }

}

export default Signizo;
